import React from "react";
import routeGuard from "src/HOC/routeGuard";
import FlightSimulatorList from "src/components/FlightSimulator/list";
import { RESOURCE_TYPE } from "src/constant/common";

const FlightSimulator = () => {
  return (
    <FlightSimulatorList />
  );
};

export default routeGuard(FlightSimulator, RESOURCE_TYPE.FLIGHT_SIMULATION);
